import * as actionTypes from "../actionTypes";
import * as criterionEditorsActions from "./criterionEditorsActions";
import * as fieldsActions from "./fieldsActions";
import * as joinpathsActions from "./joinpathsActions";
import * as query from "../lib/api/query";
import * as util from "../lib/search/util";

export function targetsSet(targets, libraryName) {
	return {
		type: actionTypes.TARGETS_SET,
		targets,
		libraryName,
	};
}

function targetsReset() {
	return {
		type: actionTypes.TARGETS_RESET,
	};
}

export function clearTargets() {
	return dispatch => {
		dispatch(targetsReset());
	};
}

function setLibraryTargets(targets, libraryName) {
	return dispatch => {
		const fields = [];
		const joinpaths = [];

		const mappedTargets = targets.map(t => {
			const mappedFields = t.fields.map(util.cloneWithId);
			const mappedJoinpaths = t.joinpaths.map(util.cloneWithId);
			fields.push(...mappedFields);
			joinpaths.push(...mappedJoinpaths);

			const tabs = t.tabs ? t.tabs : [];

			return {
				...t,
				fields: mappedFields,
				joinpaths: mappedJoinpaths,

				tabs: tabs.map(tab => ({
					criteria: tab.criteria,
					icon_name: tab.icon_name,
					label: tab.label,
					profile: tab.profile,
				})),
			};
		});

		dispatch(fieldsActions.fieldsSet(fields));
		dispatch(joinpathsActions.joinpathsSet(joinpaths));
		return dispatch(targetsSet(mappedTargets, libraryName));
	};
}

export function loadRemainingTargets() {
	return (dispatch, getState) => {
		const state = getState();
		const libraryNames = Object.keys(state.library);
		if (!libraryNames.length) {
			return Promise.reject(new Error("Libraries must be loaded before targets."));
		}

		const unloadedLibraries = libraryNames
			.map(l => state.library[l])
			.filter(l => !l.targetsLoaded);
		if (!unloadedLibraries.length) {
			return Promise.resolve();
		}

		const loadEditors = Object.keys(state.criterionEditors).length
			? Promise.resolve(null)
			: query.editors();

		return loadEditors
			.then(editors => {
				if (editors) {
					dispatch(criterionEditorsActions.criteriaSet(editors));
				}
				return Promise.map(unloadedLibraries, library => query.targets(library.name));
			})
			.then(libraryTargets => {
				libraryTargets.forEach((targets, i) => {
					const library = unloadedLibraries[i];
					return dispatch(setLibraryTargets(targets, library.name));
				});
			});
	};
}

export function loadLibraryTargets(libraryName) {
	return (dispatch, getState) => {
		const state = getState();
		if (
			!libraryName ||
			!state.library[libraryName] ||
			state.library[libraryName].targetsLoaded
		) {
			return Promise.resolve();
		}

		const loadEditors = Object.keys(state.criterionEditors).length
			? Promise.resolve(null)
			: query.editors();

		return Promise.all([query.targets(libraryName), loadEditors]).then(([targets, editors]) => {
			if (editors) {
				dispatch(criterionEditorsActions.criteriaSet(editors));
			}
			return dispatch(setLibraryTargets(targets, libraryName));
		});
	};
}
